export default {
  timeHost: 'https://time.geekbang.org',
  infoQHost: 'https://www.infoq.cn',
  ENV: 'prod'
}
